import { render, staticRenderFns } from "./bottomBarItem.vue?vue&type=template&id=1119b43a&scoped=true&"
import script from "./bottomBarItem.vue?vue&type=script&lang=js&"
export * from "./bottomBarItem.vue?vue&type=script&lang=js&"
import style0 from "./bottomBarItem.vue?vue&type=style&index=0&id=1119b43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119b43a",
  null
  
)

export default component.exports